import { maxZoomFactor, minZoomFactor, zoomFactorValue, zoomFactorValues } from "../components/Solution/Preview.types";

const getClosestZoomFactorToWidth = (imageWidth: number, realCardWidth: number) => {
    let closestZoomFactor = zoomFactorValues[0];
    zoomFactorValues.forEach((value) => {
        if (Math.abs(imageWidth - value * realCardWidth) < Math.abs(imageWidth - closestZoomFactor * realCardWidth)) {
            closestZoomFactor = value;
        }
    });
    return closestZoomFactor;
};

const isSpecialZoomFactor = (zoomFactor: number) => {
    return zoomFactor === zoomFactorValue.screenWidth || zoomFactor === zoomFactorValue.screenWidthAndHeight
};

const getNextZoomFactor = (currentZoomFactor: zoomFactorValue, step: number) => {
    const currentIndex = zoomFactorValues.indexOf(currentZoomFactor);
    return zoomFactorValues[currentIndex + step];
};

export const zoomIn = (zoomFactor: number, realCardWidth: number, ref: React.RefObject<any>, setZoomFactorFunc: (value: React.SetStateAction<number>) => void) => {
    if (zoomFactor >= maxZoomFactor) return;
    if (isSpecialZoomFactor(zoomFactor)) {
        const width = ref.current?.clientWidth;
        const closestZoomFactor = width ? getClosestZoomFactorToWidth(width, realCardWidth) : zoomFactorValue.percent200;
        let newZoomFactor = closestZoomFactor;
        if (width && closestZoomFactor * realCardWidth < width) {
            newZoomFactor = getNextZoomFactor(closestZoomFactor, 1);
        }
        setZoomFactorFunc(newZoomFactor);
    } else setZoomFactorFunc(getNextZoomFactor(zoomFactor, 1));
}

export const zoomOut = (zoomFactor: number, realCardWidth: number, ref: React.RefObject<any>, setZoomFactorFunc: (value: React.SetStateAction<number>) => void) => {
    if (zoomFactor <= minZoomFactor) return;
    if (isSpecialZoomFactor(zoomFactor)) {
        const width = ref.current?.clientWidth;
        const closestZoomFactor = width ? getClosestZoomFactorToWidth(width, realCardWidth) : zoomFactorValue.percent200;
        let newZoomFactor = closestZoomFactor;
        if (width && closestZoomFactor * realCardWidth > width) {
            newZoomFactor = getNextZoomFactor(closestZoomFactor, -1);
        }
        setZoomFactorFunc(newZoomFactor);
    } else setZoomFactorFunc(getNextZoomFactor(zoomFactor, -1));
}